<template>
    <div class="main-content events-list events-view">
        <div class="container">
            <div id="events-list-container" class="events" style="padding-top: 0px; height:initial;">
                <div>
                    <div v-for="(month_events, i) in persons_events">
                        <event-group
                            @changed="event_checked"
                            :ref="'month_' + i"
                            :i="i"
                            :month_events="month_events"
                            :key="Object.keys(month_events).toString()"
                        ></event-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import iconDropdown from "@/components/pages/icon-dropdown.vue";
import EventGroup from "./people-invite-event-group";

export default {
    name: "people-events",
    components: { iconDropdown, EventGroup },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_empty_person();
            if (to.params && to.params.id) {
                vm.get_current_person(to.params.id);
                vm.get_person_events(to.params.id);
                vm.set_event_ids([]);
            }
            next();
        });
    },
    data() {
        return {
            ev_ids: []
        };
    },
    computed: {
        ...mapState("StorePeople", ["persons_events", "event_ids", "person"])
    },
    methods: {
        ...mapActions("StorePeople", ["get_person", "get_person_events"]),
        ...mapMutations("StorePeople", ["clear_person", "set_event_ids", "set_invite_btn_mode"]),
        set_empty_person() {
            this.clear_person();
        },
        event_checked(pl) {
            if (pl.event.target.checked) {
                if (!this.ev_ids.includes(pl.data)) {
                    this.ev_ids.push(pl.data);
                }
            } else {
                this.ev_ids = this.ev_ids.filter(item => item !== pl.data);
            }
            this.set_event_ids(this.ev_ids);
        },

        get_current_person(person_id) {
            this.get_person(person_id);
        }
    }
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
